export default __webpack_public_path__ + "static/media/manual12.39c522e0.png";